import { render, staticRenderFns } from "./CoursewareTreeItemAdder.vue?vue&type=template&id=38b4cbee&scoped=true&"
import script from "./CoursewareTreeItemAdder.vue?vue&type=script&lang=js&"
export * from "./CoursewareTreeItemAdder.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareTreeItemAdder.vue?vue&type=style&index=0&id=38b4cbee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b4cbee",
  null
  
)

export default component.exports